import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Explore.css";
import { Link } from "react-router-dom";

import Logo from "../images/as (9).webp";
import Logo1 from "../images/as (8).webp";
import Logo2 from "../images/as (7).webp";
import Logo3 from "../images/as (6).webp";
import Logo4 from "../images/car insurance.webp";
import Logo7 from "../images/Business-loan.webp";
import Logo8 from "../images/Gadget-loan.webp";
import Logo5 from "../images/Home-loan.webp";

const cards = [
  {
    title: "Bike Insurance",
    logo: Logo,
    bgColor: "#FFDFDF",
    link: "/bikeinsurance",
  },
  {
    title: "Life Insurance",
    logo: Logo1,
    bgColor: "#FFDFFC",
    link: "/Lifeinsurance",
  },
  {
    title: "Health Insurance",
    logo: Logo2,
    bgColor: "#DFE2FF",
    link: "/Healthinsurance",
  },
  {
    title: "Travel Insurance",
    logo: Logo3,
    bgColor: "#DFF5FF",
    link: "/Travelinsurance",
  },
  {
    title: "Car Insurance",
    logo: Logo4,
    bgColor: "#FFFCDF",
    link: "/carinsurance",
  },
  {
    title: "Home Insurance",
    logo: Logo5,
    bgColor: "#FFDFDF",
    link: "/HealthInsurance",
  },
  {
    title: "Business Insurance",
    logo: Logo7,
    bgColor: "#DFE2FF",
    link: "/business",
  },
  {
    title: "Gadget Insurance",
    logo: Logo8,
    bgColor: "#DFF5FF",
    link: "/Gadget",
  },
];

const ExploreProduct = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [touchStartY, setTouchStartY] = useState(0);
  const [touchEndY, setTouchEndY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [animationPaused, setAnimationPaused] = useState(false);
  const [autoSlideIndex, setAutoSlideIndex] = useState(0);

  // Screen size states
  const [screenSize, setScreenSize] = useState("desktop");
  const [visibleIndicators, setVisibleIndicators] = useState(8);

  // Enhanced mobile swipe states
  const [swipeDirection, setSwipeDirection] = useState(null);
  const [swipeProgress, setSwipeProgress] = useState(0);
  const [momentumAnimation, setMomentumAnimation] = useState(false);

  // Mobile infinite loop states
  const [actualSlideIndex, setActualSlideIndex] = useState(0);
  const [isResetTransition, setIsResetTransition] = useState(false);

  const intervalRef = useRef(null);
  const autoSlideInterval = useRef(null);
  const leaveTimeout = useRef(null);
  const carouselRef = useRef(null);
  const dragStartTime = useRef(0);
  const lastTouchX = useRef(0);
  const velocity = useRef(0);
  const slidesRef = useRef(null);
  const animationFrameRef = useRef(null);
  const momentumStartTime = useRef(0);
  const initialVelocity = useRef(0);
  const resetTimeoutRef = useRef(null);

  // Create duplicated cards for infinite loop
  const duplicatedCards = isMobile
    ? [...cards, ...cards.slice(0, 2)]
    : [...cards, ...cards, ...cards];

  // Function to determine screen size and visible indicators
  const updateScreenSize = () => {
    const width = window.innerWidth;
    let newScreenSize;
    let newVisibleIndicators;

    if (width <= 768) {
      // Mobile - show 1 card at a time
      newScreenSize = "mobile";
      newVisibleIndicators = cards.length; // Show all 8 indicators for mobile
    } else if (width <= 1024) {
      // Tablet
      newScreenSize = "tablet";
      newVisibleIndicators = 3;
    } else {
      // Desktop and Large Desktop
      newScreenSize = "desktop";
      newVisibleIndicators = 8;
    }

    setScreenSize(newScreenSize);
    setVisibleIndicators(newVisibleIndicators);
    setIsMobile(width <= 991);
  };

  // Handle infinite loop reset for mobile
  const handleInfiniteLoop = (slideIndex) => {
    if (!isMobile) return slideIndex;

    // If we've reached beyond the original cards length, reset to beginning
    if (slideIndex >= cards.length) {
      // Clear any existing timeout
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
      }

      // Set a short delay to allow smooth transition completion
      resetTimeoutRef.current = setTimeout(() => {
        setIsResetTransition(true);
        setCurrentSlide(0);
        setActualSlideIndex(0);
        setActiveIndex(0);

        // Remove reset transition flag after a brief moment
        setTimeout(() => {
          setIsResetTransition(false);
        }, 50);
      }, 300);

      return slideIndex; // Return current index for smooth transition
    }

    return slideIndex;
  };

  useEffect(() => {
    updateScreenSize();
    startAutoSlide();

    const handleResize = () => {
      updateScreenSize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(intervalRef.current);
      clearInterval(autoSlideInterval.current);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
      }
      if (leaveTimeout.current) {
        clearTimeout(leaveTimeout.current);
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Auto slide effect for indicators
  const startAutoSlide = () => {
    // Clear any existing intervals
    clearInterval(autoSlideInterval.current);
    
    autoSlideInterval.current = setInterval(
      () => {
        if (!animationPaused && !isDragging && !isHovering) {
          if (isMobile) {
            // Mobile: go through each card one by one with infinite loop
            setCurrentSlide((prevSlide) => {
              const nextSlide = prevSlide + 1;
              const actualNext = nextSlide % cards.length;

              setActualSlideIndex(actualNext);
              setActiveIndex(actualNext);
              setAutoSlideIndex(actualNext);

              // Handle infinite loop
              return handleInfiniteLoop(nextSlide);
            });
          } else {
            // Desktop: original behavior
            setAutoSlideIndex((prevIndex) => {
              const nextIndex = (prevIndex + 1) % visibleIndicators;
              setCurrentSlide(nextIndex);
              setActiveIndex(nextIndex);
              return nextIndex;
            });
          }
        }
      },
      isMobile ? 3000 : 3000
    ); // 3 seconds for mobile
  };

  // Restart auto slide when visible indicators change
  useEffect(() => {
    startAutoSlide();
  }, [visibleIndicators, isMobile, animationPaused, isDragging, isHovering]);

  const pauseAnimation = () => {
    console.log('Pausing animation'); // Debug log
    setAnimationPaused(true);
    if (slidesRef.current && !isMobile) {
      slidesRef.current.style.animationPlayState = "paused";
    }
    clearInterval(autoSlideInterval.current);
  };

  const resumeAnimation = () => {
    console.log('Resuming animation'); // Debug log
    setAnimationPaused(false);
    if (slidesRef.current && !isMobile) {
      slidesRef.current.style.animationPlayState = "running";
    }
    // Start auto slide immediately
    startAutoSlide();
  };

  const handleMouseEnter = (index) => {
    console.log('Mouse entered card:', index); // Debug log
    // Clear any pending leave timeout
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
      leaveTimeout.current = null;
    }
    
    setHoveredIndex(index);
    setActiveIndex(index);
    setIsHovering(true);
    pauseAnimation();
  };

  const handleMouseLeave = () => {
    console.log('Mouse left card'); // Debug log
    
    // Clear any existing leave timeout
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }
    
    // Set a new timeout for smoother UX
    leaveTimeout.current = setTimeout(() => {
      console.log('Processing mouse leave after timeout'); // Debug log
      setHoveredIndex(null);
      setIsHovering(false);
      // Resume animation immediately after state update
      resumeAnimation();
    }, 150); // Reduced timeout for better responsiveness
  };

  const handleCardIndicatorClick = (cardIndex) => {
    console.log('Indicator clicked:', cardIndex); // Debug log
    
    // Clear any existing timeouts
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
      leaveTimeout.current = null;
    }
    
    if (isMobile) {
      setCurrentSlide(cardIndex);
      setActualSlideIndex(cardIndex);
      setActiveIndex(cardIndex);
      setAutoSlideIndex(cardIndex);
    } else {
      setCurrentSlide(cardIndex);
      setActiveIndex(cardIndex);
      setAutoSlideIndex(cardIndex);
    }

    // Pause animation temporarily
    pauseAnimation();

    // Resume after a delay
    setTimeout(() => {
      if (!isHovering) { // Only resume if not hovering
        resumeAnimation();
      }
    }, 2000); // Reduced from 3000ms to 2000ms
  };

  const animateMomentum = (startOffset, targetOffset, initialVel) => {
    const startTime = Date.now();
    const duration = Math.min(800, Math.max(300, Math.abs(initialVel) * 200));

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Smooth easing function with momentum
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentOffset =
        startOffset + (targetOffset - startOffset) * easeOut;

      setDragOffset(currentOffset);

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDragOffset(0);
        setMomentumAnimation(false);
        setIsTransitioning(false);
        setTimeout(() => {
          if (!isHovering && !isDragging) { // Check conditions before resuming
            resumeAnimation();
          }
        }, 500);
      }
    };

    setMomentumAnimation(true);
    animate();
  };

  // Enhanced touch handling for mobile
  const handleTouchStart = (e) => {
    if (!isMobile) return;

    // Cancel any ongoing momentum animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    const touch = e.touches[0];
    setTouchStartX(touch.clientX);
    setTouchStartY(touch.clientY);
    setTouchEndX(touch.clientX);
    setTouchEndY(touch.clientY);
    setIsDragging(true);
    setIsTransitioning(false);
    setMomentumAnimation(false);
    setSwipeDirection(null);
    setSwipeProgress(0);

    lastTouchX.current = touch.clientX;
    dragStartTime.current = Date.now();
    velocity.current = 0;

    pauseAnimation();
  };

  const handleTouchMove = (e) => {
    if (!isMobile || !isDragging || momentumAnimation) return;

    e.preventDefault();

    const touch = e.touches[0];
    const currentX = touch.clientX;
    const currentY = touch.clientY;

    setTouchEndX(currentX);
    setTouchEndY(currentY);

    const deltaX = currentX - lastTouchX.current;
    const currentTime = Date.now();
    const deltaTime = currentTime - dragStartTime.current;

    // Calculate smooth velocity
    if (deltaTime > 0) {
      const newVelocity = deltaX / Math.max(deltaTime, 1);
      velocity.current = velocity.current * 0.8 + newVelocity * 0.2;
    }
    lastTouchX.current = currentX;

    const dragDistance = currentX - touchStartX;
    const verticalDistance = Math.abs(currentY - touchStartY);

    if (verticalDistance < 80) {
      const containerWidth = carouselRef.current?.offsetWidth || 300;
      const maxDrag = containerWidth * 0.3;

      let resistance = 1;
      if (Math.abs(dragDistance) > maxDrag * 0.6) {
        resistance = 0.3;
      }

      const smoothDrag = dragDistance * resistance;
      const clampedDrag = Math.max(-maxDrag, Math.min(maxDrag, smoothDrag));

      setDragOffset(clampedDrag);

      if (Math.abs(dragDistance) > 20) {
        setSwipeDirection(dragDistance > 0 ? "right" : "left");
        setSwipeProgress(
          Math.min(Math.abs(dragDistance) / (containerWidth * 0.3), 1)
        );
      }
    }
  };

  const handleTouchEnd = () => {
    if (!isMobile || !isDragging || momentumAnimation) return;

    setIsDragging(false);

    const deltaX = touchEndX - touchStartX;
    const deltaY = Math.abs(touchEndY - touchStartY);
    const swipeThreshold = 50;
    const velocityThreshold = 0.3;
    const minSwipeDistance = 30;

    // Only process horizontal swipes
    if (deltaY < 100) {
      const absVelocity = Math.abs(velocity.current);
      const absDeltaX = Math.abs(deltaX);

      const isSignificantSwipe =
        absDeltaX > swipeThreshold ||
        (absVelocity > velocityThreshold && absDeltaX > minSwipeDistance);

      if (isSignificantSwipe) {
        setIsTransitioning(true);

        let newIndex = currentSlide;

        if (deltaX > 0 || velocity.current > velocityThreshold) {
          // Swipe right - go to previous
          newIndex = currentSlide === 0 ? cards.length - 1 : currentSlide - 1;
        } else if (deltaX < 0 || velocity.current < -velocityThreshold) {
          // Swipe left - go to next
          newIndex = currentSlide + 1;
        }

        if (newIndex !== currentSlide) {
          // Update slide with infinite loop handling
          const actualIndex = newIndex % cards.length;
          setCurrentSlide(handleInfiniteLoop(newIndex));
          setActualSlideIndex(actualIndex);
          setActiveIndex(actualIndex);
          setAutoSlideIndex(actualIndex);

          // Animate transition
          animateMomentum(
            dragOffset,
            deltaX > 0 ? 100 : -100,
            velocity.current
          );
        } else {
          // Snap back to original position
          animateMomentum(dragOffset, 0, velocity.current * 0.5);
        }
      } else {
        // Quick snap back for small movements
        animateMomentum(dragOffset, 0, 0);
      }
    } else {
      // Reset for vertical scrolls
      setDragOffset(0);
      setMomentumAnimation(false);
      setTimeout(() => {
        if (!isHovering && !isDragging) {
          resumeAnimation();
        }
      }, 300);
    }

    // Reset swipe states
    setSwipeDirection(null);
    setSwipeProgress(0);
  };

  const handleContextMenu = (e) => {
    if (isMobile && (isDragging || momentumAnimation)) {
      e.preventDefault();
    }
  };

  return (
    <div className="row mt-5 mx-auto">
      <div className="col-12 col-md-12">
        <section className="TypesPayment">
          <div className="container py-1">
            <h2
              className="text-center mb-4 fw-semibold"
              style={{ color: "#4B4B4B" }}
            >
              Types of Insurance <br className="d-block d-sm-none" /> We Offer
            </h2>

            <div
              className="carousel-container mx-auto overflow-hidden position-relative"
              style={{
                maxWidth: isMobile ? "100%" : "1000px",
                touchAction: isMobile ? "pan-y pinch-zoom" : "auto",
              }}
              ref={carouselRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onContextMenu={handleContextMenu}
            >
              <div
                ref={slidesRef}
                className="carousel-slides d-flex"
                style={{
                  transform: isMobile
                    ? `translateX(calc(-${
                        currentSlide * 100
                      }% + ${dragOffset}px))`
                    : undefined,
                  transition:
                    isDragging || momentumAnimation || isResetTransition
                      ? "none"
                      : isMobile
                      ? "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
                      : undefined,
                  animationPlayState: animationPaused ? "paused" : "running",
                  willChange: isMobile ? "transform" : "auto",
                }}
              >
                {duplicatedCards.map((card, index) => {
                  const originalIndex = isMobile
                    ? index % cards.length
                    : index % cards.length;
                  const displayIndex = isMobile
                    ? actualSlideIndex
                    : activeIndex;
                  const isActive = displayIndex === originalIndex;
                  const isHovered = hoveredIndex === originalIndex;
                  const isCardActive = isHovered;

                  return (
                    <div
                      key={
                        isMobile
                          ? index
                          : `${originalIndex}-${Math.floor(
                              index / cards.length
                            )}`
                      }
                      className="carousel-slide flex-shrink-0 d-flex flex-column align-items-center"
                      style={{
                        minWidth: isMobile ? "100%" : undefined,
                        transform:
                          isMobile && isDragging && swipeProgress > 0
                            ? `scale(${1 + swipeProgress * 0.02})`
                            : "none",
                        transition: isDragging
                          ? "none"
                          : "transform 0.2s ease-out",
                      }}
                    >
                      <div
                        className="card-custom position-relative"
                        style={{
                          backgroundColor: card.bgColor,
                          borderRadius: isCardActive ? "50%" : "8px",
                          width:
                            screenSize === "mobile"
                              ? "200px"
                              : screenSize === "tablet"
                              ? "400px"
                              : "158px",
                          height:
                            screenSize === "mobile"
                              ? "200px"
                              : screenSize === "tablet"
                              ? "400px"
                              : "158px",
                          transition: "all 0.3s ease-in-out",
                          overflow: isCardActive ? "visible" : "hidden",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          MozUserSelect: "none",
                          margin: "0 10px",
                          boxShadow:
                            isMobile && isDragging && swipeProgress > 0.3
                              ? `0 8px 25px rgba(0,0,0,0.15)`
                              : "none",
                        }}
                        onMouseEnter={() =>
                          !isMobile && handleMouseEnter(originalIndex)
                        }
                        onMouseLeave={() => !isMobile && handleMouseLeave()}
                        onTouchStart={() =>
                          !isDragging && handleMouseEnter(originalIndex)
                        }
                      >
                        <div className="card-body-custom d-flex align-items-center justify-content-center w-100 h-100">
                          <Link
                            to={card.link}
                            className="text-decoration-none"
                            style={{
                              outline: "none",
                              border: "none",
                              boxShadow: "none",
                              display: "block",
                              position: "relative",
                              width: "100%",
                              height: "100%",
                            }}
                            onFocus={(e) => e.target.blur()}
                          >
                            <img
                              src={card.logo}
                              alt={card.title}
                              className="logo-img"
                              style={{
                                width:
                                  screenSize === "mobile"
                                    ? isCardActive
                                      ? "170px"
                                      : "130px"
                                    : screenSize === "tablet"
                                    ? isCardActive
                                      ? "300px"
                                      : "260px"
                                    : isCardActive
                                    ? "200px"
                                    : "160px", // desktop
                                height:
                                  screenSize === "mobile"
                                    ? isCardActive
                                      ? "170px"
                                      : "130px"
                                    : screenSize === "tablet"
                                    ? isCardActive
                                      ? "300px"
                                      : "260px"
                                    : isCardActive
                                    ? "200px"
                                    : "160px",
                                transition: "all 0.3s ease-in-out",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: isCardActive ? 3 : 2,
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                              }}
                              draggable={false}
                              onFocus={(e) => e.target.blur()}
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="w-100 text-center py-2">
                        <Link
                          to={card.link}
                          className="text-decoration-none text-dark"
                        >
                          <h6
                            className="mb-0"
                            style={{ fontFamily: "poppins", fontSize: "20px" }}
                          >
                            {card.title}
                          </h6>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Responsive Indicators */}
            <div className="d-flex mt-3 justify-content-center flex-wrap">
              {Array.from(
                { length: isMobile ? cards.length : visibleIndicators },
                (_, index) => (
                  <button
                    key={index}
                    className={`carousel__indicator mx-1 mb-1 ${
                      index === (isMobile ? actualSlideIndex : currentSlide)
                        ? "active"
                        : ""
                    }`}
                    onClick={() => handleCardIndicatorClick(index)}
                    aria-label={`Go to card ${index + 1}`}
                    style={{
                      opacity: isDragging ? 0.5 : 1,
                      transition:
                        "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                      transform:
                        isMobile && isDragging && index === actualSlideIndex
                          ? `scale(${1 + swipeProgress * 0.2})`
                          : "scale(1)",
                    }}
                  />
                )
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ExploreProduct;